import ValuerAmendFieldListHandler from "./ValuerAmendFieldListHandler";
import {useEffect, useState} from "react";
import ValuerAmendMultiSelectButton from "./ValuerAmendMultiSelectButton";
import custom_delete from "../../assets/cross.svg"
import plus from "../../assets/plus.svg"
import valuer_api from "../../api/valuer";

const ValuerAmendMultiSelect = (props) => {

    // For Saving
    const summaryId = props.summaryId
    const section = props.sectionName
    const identifier = props.identifier

    // Required
    const field = props.field
    const options = props.options ? props.options : [];

    // Optional
    const flex = props.flex ? props.flex : false
    const optionsFlex = props.optionsFlex ? props.optionsFlex : false
    const defaultValue = props.defaultValue ? props.defaultValue : false
    const customInput = props.customInput ? props.customInput : false
    const customInputButtonText = props.customInputButtonText ? props.customInputButtonText : "Add"

    // Value
    const [values, setValues] = useState({})
    const [customValues, setCustomValues] = useState({})

    // Additional Fields
    const showValueDependantFields = props.showValueDependantFields ? props.showValueDependantFields : false
    const valueDependantFields = props.valueDependantFields ? props.valueDependantFields : []

    // Saving Tracker
    const UpdateParentValue = props.UpdateParentValue
    const AddToQueue = props.AddToQueue
    const RemoveFromQueue = props.RemoveFromQueue
    const AddToErroredSaves = props.AddToErroredSaves

    // Error Handling
    const setErrorMessage = props.setErrorMessage
    const setErrorTitle = props.setErrorTitle

    useEffect(() => {
        if (props.value === undefined) {
            if (!defaultValue) return;
            setValues(defaultValue);
            return;
        }

        const fullValue = props.value;
        setValues(fullValue);

        const customRaw = fullValue?.[`${identifier}-custom`] ?? {};

        if (customRaw && typeof customRaw === 'object') {
            const filtered = Object.entries(customRaw)
                .filter(([, v]) => v && v.value !== null)
                .reduce((acc, [k, v]) => {
                    acc[k] = v;
                    return acc;
                }, {});
            setCustomValues(filtered);
        } else {
            setCustomValues({});
        }
    }, [props.value, defaultValue, identifier]);


    const updateMultiSelectButtons = (child_identifier, _value) => {
        let idx = options.map(x => x.identifier).indexOf(child_identifier)
        let current_option = options[idx]

        if (!child_identifier) return
        let updateTime = Date.now()
        AddToQueue(section, child_identifier, updateTime)
        if (_value) {
            if ("value" in current_option) {
                _value = current_option.value
            } else {
                _value = "1"
            }
        } else {
            _value = "0"
        }
        let body = { "value": _value }
        setValues(v => {
            let _v_copy = Object.assign({}, v);
            _v_copy[child_identifier] = _value
            return _v_copy
        })
        UpdateParentValue(identifier, _value, child_identifier)
        let response = valuer_api.ValuerAmendPut(summaryId, identifier, child_identifier, body);
        response.then(
            response => {
                RemoveFromQueue(section, child_identifier, updateTime)
            }
        ).catch((err) => {
            AddToErroredSaves(section, child_identifier, updateTime)
            setErrorTitle("Failed to Save")
            setErrorMessage("The request to save a field has failed")
        })
    }

    const RemoveCustomField = (idx) => {
        if (idx === undefined || idx === null) return;
        const updateTime = Date.now();
        AddToQueue(section, `${identifier}-custom`, updateTime);

        setCustomValues(prev => {
            const updated = { ...prev };

            // Set the row's value to null
            if (updated[idx]) {
                updated[idx] = { value: null };
            }

            const payload = {
                value: null,
                row: parseInt(idx)
            };

            valuer_api.ValuerAmendPut(summaryId, `${identifier}-custom`, "value", payload)
                .then(() => {
                    RemoveFromQueue(section, `${identifier}-custom`, updateTime);
                })
                .catch(() => {
                    AddToErroredSaves(section, `${identifier}-custom`, updateTime);
                    setErrorTitle("Failed to Save");
                    setErrorMessage("The request to save a field has failed");
                });


            UpdateParentValue(identifier, updated, `${identifier}-custom`);
            return updated;
        });
    };


    const AddNewCustom = () => {
        setCustomValues(cv => {
            let obj = Object.assign({}, cv)
            let keys = []
            Object.keys(cv).forEach(x => keys.push(parseInt(x)))
            let row_id = 1
            if (keys.length) {
                row_id = Math.max(...keys) + 1
            }
            obj[row_id] = {"value": ""}
            return obj
        })
    }

    const ClickOffCustomFields = (idx) => {
        // Check for required fields and then submit change
        if (!summaryId || !section || !identifier) return
        CustomValuesUpdate(idx)
    }

    const CustomValuesUpdate = (idx) => {
        let updateTime = Date.now();
        AddToQueue(`${identifier}-custom`, "value", updateTime);
        let body = {
            "value": customValues[idx],
            "row": parseInt(idx) // ✅ use the actual key
        };
        UpdateParentValue(identifier, customValues, `${identifier}-custom`);
        valuer_api.ValuerAmendPut(summaryId, `${identifier}-custom`, "value", body)
            .then(() => {
                RemoveFromQueue(section, `${identifier}-custom`, updateTime);
            })
            .catch((err) => {
                AddToErroredSaves(section, `${identifier}-custom`, updateTime);
                setErrorTitle("Failed to Save");
                setErrorMessage("The request to save a field has failed");
            });
    };


    const checkSelected = (value) => {
        // returns false if no value found
        if(!value) return false
        // returns true if value was found that could not be converted to int
        let selected = parseInt(value)
        if (isNaN(selected)) {
            return true
        }
        return selected
    }

    return (
        <>
            <div className={"valuer-amend-multi-select-field-container" + (flex ? " inline" : "")}>
                <div className="valuer-amend-multi-select-label"> {field && field} </div>
                <div className={"valuer-amend-multi-select-buttons-container" + (optionsFlex ? " inline" : "")}>
                    {options && options.map((option) => {
                        return (
                            <ValuerAmendMultiSelectButton identifier={option.identifier}
                                                          label={option.label}
                                                          selected={values && checkSelected(values[option.identifier])}
                                                          inline={props.flex}
                                                          updateFunction={updateMultiSelectButtons.bind(this)} />
                        )
                    })}
                </div>
            </div>
            {customInput && customInputButtonText ?
                <div className="valuer-amend-custom-multi-select-container">
                    {customValues && Object.keys(customValues).map((idx) => {
                        const val = customValues[idx];
                        if (!val || val.value === null) return null;

                        return (
                            <div className="valuer-amend-custom-multi-select" key={idx}>
                                <textarea
                                    value={val.value}
                                    className="valuer-amend-field"
                                    onChange={ev => {
                                        setCustomValues(cv => {
                                            let cv_copy = { ...cv };
                                            cv_copy[idx] = ev.target.value;
                                            return cv_copy;
                                        });
                                    }}
                                    onBlur={() => ClickOffCustomFields(idx)}
                                />
                                <div className="valuer-amend-custom-multi-select-delete-container link"
                                     onClick={() => RemoveCustomField(idx)}>
                                    <img src={custom_delete} alt={"Delete"} />
                                </div>
                            </div>
                        );
                    })}


                    <div className="valuer-amend-custom-multi-select-button-container link" onClick={() => AddNewCustom()}>
                        <div className="button-image-container">
                            <img src={plus} alt={"Add"}/>
                        </div>
                        <div className="button-text-container">
                            {customInputButtonText ? customInputButtonText : "Add"}
                        </div>
                    </div>
                </div>
                : null
            }
            {valueDependantFields && valueDependantFields.map((fields, idx) => {
                return (
                    <>
                        {(values && ((fields.requirement && values.includes(fields.requirement.value))))
                        || (values && (fields.antiRequirement && !(values.includes(fields.antiRequirement.value))))
                            ? <ValuerAmendFieldListHandler fieldList={fields.fields}
                                                           sectionName={section}
                                                           summaryId={summaryId}
                                                           setErrorMessage={setErrorMessage}
                                                           setErrorTitle={setErrorTitle}
                                                           UpdateParentValue={UpdateParentValue}
                                                           AddToQueue={AddToQueue}
                                                           RemoveFromQueue={RemoveFromQueue}
                                                           AddToErroredSaves={AddToErroredSaves}/>

                            : (showValueDependantFields ?
                                <div className="valuer-amend-disabled-container">
                                    <ValuerAmendFieldListHandler fieldList={fields.fields}
                                                                 sectionName={section}
                                                                 summaryId={summaryId}
                                                                 setErrorMessage={setErrorMessage}
                                                                 setErrorTitle={setErrorTitle}
                                                                 UpdateParentValue={UpdateParentValue}
                                                                 AddToQueue={AddToQueue}
                                                                 RemoveFromQueue={RemoveFromQueue}
                                                                 AddToErroredSaves={AddToErroredSaves}/>
                                </div>
                                : null)
                        }
                    </>
                )
            })}
        </>
    )
}

export default ValuerAmendMultiSelect